import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Rider } from '@app/rest-client/faxe/models/rider';
import { addManyRider, purgeRider, removeAll, updateManyRider, upsetOne } from '@app/store/faxe/rider/rider.actions';
import { sapiensEntityState, SliceState } from '@app/store/faxe/sapiens-entity-state';

export const identifier = (rider: Rider): string => rider.riderGuid;

export const adapter: EntityAdapter<Rider> = createEntityAdapter<Rider>({
  selectId: identifier
});

export type RiderEntityState = sapiensEntityState<Rider>;

export const initialState: RiderEntityState = adapter.getInitialState({
  meta: {
    sliceState: SliceState.inital,
    timestamp: Date.now()
  }
});

const reducer = createReducer(
  initialState,
  on(removeAll, (state) => ({
    ...adapter.removeAll(state),
    meta: {
      ...state.meta,
      isReportable: undefined,
      timestamp: Date.now()
    }
  })),
  on(addManyRider, (state, { models, sliceState, issuerStack }) => ({
    ...adapter.addMany(models, state),
    meta: {
      ...state.meta,
      sliceState,
      issuerStack,
      timestamp: Date.now()
    }
  })),
  on(upsetOne, (state, { model }) => ({
    ...adapter.upsertOne(model, state),
    meta: {
      ...state.meta,
      timestamp: Date.now()
    }
  })),
  on(updateManyRider, (state, { models }) => ({
    ...adapter.upsertMany(models, state),
    meta: {
      ...state.meta,
      timestamp: Date.now()
    }
  })),
  on(purgeRider, (state) => ({
    ...adapter.removeAll(state),
    meta: {
      ...state.meta,
      isReportable: undefined,
      timestamp: Date.now()
    }
  }))
);

export const riderReducer: (state: (RiderEntityState | undefined), action: Action) =>
  sapiensEntityState<Rider> = (state: RiderEntityState | undefined, action: Action) =>
  reducer(state, action);

// get the selectors
const {
  selectAll
} = adapter.getSelectors();

// select the array of users
export const selectAllRider = selectAll;


